import { render, staticRenderFns } from "./AddPublishingScheduleTierAction.vue?vue&type=template&id=3144030a&scoped=true&"
import script from "./AddPublishingScheduleTierAction.vue?vue&type=script&lang=js&"
export * from "./AddPublishingScheduleTierAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3144030a",
  null
  
)

export default component.exports